import Footer from '../Components/Footer/Footer.js'

function Termos() {
  return (
    <div>
     <div className="Privacidade-background">
      <div className="privacidade-conteudo">
        
        <h1 className="titulo-principal">Termos de Uso</h1>
        
        <p>
          Insira Termos Aqui
        </p>
        <p>
          Insira Termos Aqui
        </p>
        <p>
          Insira Termos Aqui
        </p>
        <p>
          Insira Termos Aqui
        </p>
        </div>
      </div>
      <div className="App">
        <Footer/>
      </div>
    </div>
  )
}

export default Termos;
